import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { useTranslation } from "react-i18next";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export default function RetentionFields({ value, onChange }) {
  const { t } = useTranslation();
  const v = value || {};
  const set = (k) => (e) => onChange({ ...v, [k]: e?.target ? Number(e.target.value) : e });

  return (
    <div className="border border-border bg-secondary p-4 space-y-3" data-testid="retention-fields">
      <Label className="font-mono text-[11px] uppercase tracking-wide text-muted-foreground">{t("retention.policy")}</Label>
      <Select value={v.mode} onValueChange={(m) => onChange({ ...v, mode: m })}>
        <SelectTrigger className="rounded-none" data-testid="retention-mode"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="keep_last_n">{t("retention.keepLastN")}</SelectItem>
          <SelectItem value="keep_days">{t("retention.keepDays")}</SelectItem>
          <SelectItem value="gfs">{t("retention.gfs")}</SelectItem>
          <SelectItem value="never">{t("retention.never")}</SelectItem>
        </SelectContent>
      </Select>
      {v.mode === "keep_last_n" && (
        <div className="space-y-1.5">
          <Label className="text-xs">{t("retention.keepLast")}</Label>
          <Input type="number" value={v.keep_last_n} onChange={set("keep_last_n")} className="rounded-none" />
        </div>
      )}
      {v.mode === "keep_days" && (
        <div className="space-y-1.5">
          <Label className="text-xs">{t("retention.keepDaysLabel")}</Label>
          <Input type="number" value={v.keep_days} onChange={set("keep_days")} className="rounded-none" />
        </div>
      )}
      {v.mode === "gfs" && (
        <div className="grid grid-cols-4 gap-2">
          {[["gfs_hourly", t("retention.hourly")], ["gfs_daily", t("retention.daily")], ["gfs_weekly", t("retention.weekly")], ["gfs_monthly", t("retention.monthly")]].map(([k, l]) => (
            <div key={k} className="space-y-1">
              <Label className="text-[10px]">{l}</Label>
              <Input type="number" value={v[k]} onChange={set(k)} className="rounded-none" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
